import { ScrollBackBtn } from "../../../components/atoms/Button";
interface Props {
  current: number;
  hasHouse: boolean | undefined;
  setHasHouse: (value: boolean) => void;
  onPrev: (value: number) => void;
}

export const Question3 = ({
  current,
  hasHouse,
  setHasHouse,
  onPrev,
}: Props) => {
  return (
    <section
      className={`cardContainer fade-in-slide-up ${
        current === 3 ? "currentCard" : ""
      }`}
      id="question-3"
    >
      <ScrollBackBtn onClick={() => onPrev(2)} />
      <div className="cardWrapper question">
        <div className="titleImage">
          <img src="/img/house.svg" alt="" />
        </div>
        <div>
          <span className="typographyAccentOrange typographyNumTextProgress">
            3&nbsp;/&nbsp;8
          </span>
          <h2 className="typographyAccentOrange typographyNumTextProgress">
            お住まいの形態は
          </h2>
        </div>
        <fieldset>
          <label>
            <input
              type="radio"
              value="true"
              aria-checked={hasHouse === true}
              onClick={() => setHasHouse(true)}
            />
            <div>
              <span>持ち家</span>
            </div>
          </label>
          <label>
            <input
              type="radio"
              value="false"
              aria-checked={hasHouse === false}
              onClick={() => setHasHouse(false)}
            />
            <div>
              <span>賃貸</span>
            </div>
          </label>
        </fieldset>
      </div>
    </section>
  );
};
